import React from 'react';

import Heading from './Heading';
import OpisHeadingu from './OpisHeadingu';


import obrazekPC from '../../../assets/pc.svg';
import obrazekCPU from '../../../assets/cpu.svg';
import obrazekBook from '../../../assets/bookDobry.svg';

import { opisy } from '../../../data/Opisy';

const SekcjaPasja = () => {
    return (
        <div className='relative top-[31rem] '>
            <div className='flex items-center justify-between '>
                <Heading numerSekcji={"02"} tytul={"INTERESTS AND PASSION"} />
                <div></div>
            </div>
            <div className='flex flex-col font-futura text-lg lg:flex-row justify-center gap-16 mt-24 lg:items-start'>
                <div></div>
                <div className='flex flex-col justify-center items-center'>
                    <img src={obrazekPC} className='w-[15rem] h-[15rem]' />
                    <OpisHeadingu default={true} fontSize={"[2rem]"} center={true} tytul={"PROJECTS"} opis={opisy[1]} />
                </div>
                <div className='flex flex-col justify-center items-center'>
                    {/* TODO: Tutaj te marginesy to takie troche wyjscie na poczekaniu, lepiej byłoby pobraz pobrazki
                                    z takim samym rozmiarem */}
                    <img src={obrazekCPU} className='w-[10rem] h-[10rem] mb-8 mt-10'></img>
                    <OpisHeadingu default={true} fontSize={"[2rem]"} center={true} tytul={"TECHNOLOGY"} opis={opisy[2]} />
                </div>
                <div className='flex flex-col justify-center items-center'>
                    <img src={obrazekBook} className='w-[15rem] h-[15rem]'></img>
                    <OpisHeadingu default={true} fontSize={"[2rem]"} center={true} tytul={"LEARNING"} opis={opisy[3]} />
                </div>
                <div></div>
            </div>
        </div>
    );
}

export default SekcjaPasja;
